<div class="job-status-dialog" [ngClass]="dialogStateClass()" data-testid="job-status-dialog" role="dialog" aria-modal="true" aria-labelledby="job-status-dialog-title">
  <!-- Header bar -->
  <div class="dialog-title-bar">
    <h3 class="dialog-title" id="job-status-dialog-title">
      @if (showErrorIcon()) { Warning } @else { New Translation Quote Request }
    </h3>
    <button class="close-btn" (click)="closeDialog()" aria-label="Close dialog" data-testid="job-status-close-btn">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M6.36436 19.0588L4.96436 17.6588L10.5644 12.0588L4.96436 6.45884L6.36436 5.05884L11.9644 10.6588L17.5644 5.05884L18.9644 6.45884L13.3644 12.0588L18.9644 17.6588L17.5644 19.0588L11.9644 13.4588L6.36436 19.0588Z"
          fill="white"
        />
      </svg>
    </button>
  </div>

  <mat-dialog-content class="dialog-body">
    <div class="status-indicator">
      <!-- Spinner (uploading / uploaded / progress) -->
      @if (showSpinner()) {
        <output class="spinner-container" aria-live="polite">
          <svg
            class="spinner-svg"
            viewBox="0 0 66 66"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <circle
              class="spinner-path"
              fill="none"
              stroke-width="5"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
            />
          </svg>
          <span class="visually-hidden">Processing…</span>
        </output>
      }

      <!-- Success icon (design-system check_circle) -->
      @if (showSuccessIcon()) {
        <div class="icon-container success">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="96"
            height="96"
            viewBox="0 0 96 96"
            fill="none"
          >
            <mask
              id="mask0_887_8265"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="96"
              height="96"
            >
              <rect width="96" height="96" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_887_8265)">
              <path
                d="M42.4002 66.4001L70.6002 38.2001L65.0002 32.6001L42.4002 55.2001L31.0002 43.8001L25.4002 49.4001L42.4002 66.4001ZM48.0002 88.0001C42.4669 88.0001 37.2669 86.9501 32.4002 84.8501C27.5336 82.7501 23.3002 79.9001 19.7002 76.3001C16.1002 72.7001 13.2502 68.4668 11.1502 63.6001C9.05024 58.7335 8.00024 53.5335 8.00024 48.0001C8.00024 42.4668 9.05024 37.2668 11.1502 32.4001C13.2502 27.5335 16.1002 23.3001 19.7002 19.7001C23.3002 16.1001 27.5336 13.2501 32.4002 11.1501C37.2669 9.05012 42.4669 8.00012 48.0002 8.00012C53.5336 8.00012 58.7336 9.05012 63.6002 11.1501C68.4669 13.2501 72.7002 16.1001 76.3002 19.7001C79.9002 23.3001 82.7502 27.5335 84.8502 32.4001C86.9502 37.2668 88.0002 42.4668 88.0002 48.0001C88.0002 53.5335 86.9502 58.7335 84.8502 63.6001C82.7502 68.4668 79.9002 72.7001 76.3002 76.3001C72.7002 79.9001 68.4669 82.7501 63.6002 84.8501C58.7336 86.9501 53.5336 88.0001 48.0002 88.0001ZM48.0002 80.0001C56.9336 80.0001 64.5002 76.9001 70.7002 70.7001C76.9002 64.5001 80.0002 56.9334 80.0002 48.0001C80.0002 39.0668 76.9002 31.5001 70.7002 25.3001C64.5002 19.1001 56.9336 16.0001 48.0002 16.0001C39.0669 16.0001 31.5002 19.1001 25.3002 25.3001C19.1002 31.5001 16.0002 39.0668 16.0002 48.0001C16.0002 56.9334 19.1002 64.5001 25.3002 70.7001C31.5002 76.9001 39.0669 80.0001 48.0002 80.0001Z"
                fill="#78C01E"
              />
            </g>
          </svg>
        </div>
      }

      <!-- Error icon (exclamation circle) -->
      @if (showErrorIcon()) {
        <div class="icon-container error">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="96"
            height="96"
            viewBox="0 0 96 96"
            fill="none"
            aria-hidden="true"
          >
            <mask
              id="mask0_2285_9193"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="96"
              height="96"
            >
              <rect width="96" height="96" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_2285_9193)">
              <path
                d="M48 68C49.1333 68 50.0833 67.6167 50.85 66.85C51.6167 66.0833 52 65.1333 52 64C52 62.8667 51.6167 61.9167 50.85 61.15C50.0833 60.3833 49.1333 60 48 60C46.8667 60 45.9167 60.3833 45.15 61.15C44.3833 61.9167 44 62.8667 44 64C44 65.1333 44.3833 66.0833 45.15 66.85C45.9167 67.6167 46.8667 68 48 68ZM44 52H52V28H44V52ZM48 88C42.4667 88 37.2667 86.95 32.4 84.85C27.5333 82.75 23.3 79.9 19.7 76.3C16.1 72.7 13.25 68.4667 11.15 63.6C9.05 58.7333 8 53.5333 8 48C8 42.4667 9.05 37.2667 11.15 32.4C13.25 27.5333 16.1 23.3 19.7 19.7C23.3 16.1 27.5333 13.25 32.4 11.15C37.2667 9.05 42.4667 8 48 8C53.5333 8 58.7333 9.05 63.6 11.15C68.4667 13.25 72.7 16.1 76.3 19.7C79.9 23.3 82.75 27.5333 84.85 32.4C86.95 37.2667 88 42.4667 88 48C88 53.5333 86.95 58.7333 84.85 63.6C82.75 68.4667 79.9 72.7 76.3 76.3C72.7 79.9 68.4667 82.75 63.6 84.85C58.7333 86.95 53.5333 88 48 88ZM48 80C56.9333 80 64.5 76.9 70.7 70.7C76.9 64.5 80 56.9333 80 48C80 39.0667 76.9 31.5 70.7 25.3C64.5 19.1 56.9333 16 48 16C39.0667 16 31.5 19.1 25.3 25.3C19.1 31.5 16 39.0667 16 48C16 56.9333 19.1 64.5 25.3 70.7C31.5 76.9 39.0667 80 48 80Z"
                fill="#DC0F0F"
              />
            </g>
          </svg>
        </div>
      }
    </div>

    <!-- Status label (Success! / Error / Processing) -->
    @if (showSuccessIcon()) {
      <h3 class="status-label success-label">Success!</h3>
    }
    @if (showErrorIcon()) {
      <h3 class="status-label error-label">{{ errorTitle() }}</h3>
    }

    <output class="status-message" aria-live="polite">
      {{ statusMessage() }}
      @if (showErrorIcon()) {
        <br />If the issue persists,
        <a href="mailto:support@astrazeneca.com" class="contact-support-link"
          >contact support</a
        >.
      }
    </output>
  </mat-dialog-content>

  @if (!showSpinner() && !showErrorIcon()) {
    <mat-dialog-actions class="dialog-actions">
      <!-- Success state: Request New Quote (outline) + Translation Manager (primary) -->
      @if (showSuccessIcon()) {
        <button
          type="button"
          class="btn btn-outline"
          (click)="requestNewQuote()"
          data-testid="job-status-request-new-quote-btn"
        >
          Request New Quote
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="navigateToTranslationManager()"
          data-testid="job-status-translation-manager-btn"
        >
          Translation Manager
        </button>
      }

      <!-- Progress state: Upload More -->
      @if (showUploadMore()) {
        <button type="button" class="btn btn-outline" (click)="closeDialog()" data-testid="job-status-upload-more-btn">
          Upload More
        </button>
      }
    </mat-dialog-actions>
  }
</div>
